import { render, staticRenderFns } from "./ResetPasswordEditor.vue?vue&type=template&id=474c4984&"
import script from "./ResetPasswordEditor.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports